import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { setListErr, setListMessage } from "../../../config/redux/alerts/alertsActions";
import { getBackendErrorMessage } from "../../common/utils/getBackendErrorMessage";
import { getLinkToFile } from "../../../connectors/clients/connectors";
import { approveDocument, cancelDocument } from "../../../connectors/store/connectors";
import { DocumentStatusEnum } from "../models/DocumentStatusEnums";
import { reloadData, setApprove, setCancel, setStoreDocs, toggleAddStoreDocPanel } from "./../../../config/redux/storeDocs/storeDocsActions";
import { Quantity } from "./../../../features/common/models/quantity.model";

export const useStoreDocsCommandBar = () => {
    const { t } = useTranslation("admin");
    const dispatch = useDispatch();
    const { selectedStoreDocs } = useSelector((state: RootStateOrAny) => state.storeDocs);
    const quantity = selectedStoreDocs[0] ? Quantity.ONE : Quantity.NONE;

    const addStoreDocs = () => {
        dispatch(toggleAddStoreDocPanel({ isOpen: true, add: true }));
    };

    const approveDoc = async () => {
        try {
            let response = await approveDocument(selectedStoreDocs[0].id);
            dispatch(reloadData({ reload: true }));
            dispatch(setApprove(true));
            dispatch(setListMessage(t("nav.operationSuccess")));
            dispatch(setStoreDocs({ selectedStoreDocs: [] }));
        } catch (err: any) {
            if (err.message && typeof err.message === 'string') {
                dispatch(setListErr(getBackendErrorMessage(err, t)));
                dispatch(reloadData({ reload: true }));
                dispatch(setStoreDocs({ selectedStoreDocs: [] }));
            };
        }
    };

    const cancelDoc = async () => {
        try {
            let response = await cancelDocument(selectedStoreDocs[0].id);
            dispatch(reloadData({ reload: true }));
            dispatch(setCancel(true));
            dispatch(setListMessage(t("nav.operationSuccess")));
            dispatch(setStoreDocs({ selectedStoreDocs: [] }));
        } catch (err: any) {
            if (err.message && typeof err.message === 'string') {
                dispatch(reloadData({ reload: true }));
                dispatch(setListErr(getBackendErrorMessage(err, t)));
                dispatch(setStoreDocs({ selectedStoreDocs: [] }));
            }
        }
    };

    const downloadFile = async () => {
        try {
            if (selectedStoreDocs[0].fileExists) {
                const url = await getLinkToFile(selectedStoreDocs[0].blobFileName);
                const link = document.createElement('a');
                link.href = url.data;
                //link.setAttribute('download', selectedIds[0].originalFileName);
                document.body.appendChild(link);
                link.click();
            }
        } catch (err: any) {
            if (err.message && typeof err.message === 'string') {
                dispatch(setListErr(t("nav.downloadError")));
            }
        }
    }

    const showDetails = () => {
        dispatch(toggleAddStoreDocPanel({ isOpen: true, add: false }));
    }

    const generateItems = () => {
        switch (quantity) {
            case Quantity.NONE:
                return [{
                    key: "add",
                    text: t("nav.add"),
                    iconProps: { iconName: "reportdocument" },
                    name: "prepare",
                    onClick: addStoreDocs,
                },
                ]
            case Quantity.ONE:
                let downloadButton: any[] = []
                let showButton = [{
                    key: "showFile",
                    text: t("nav.see"),
                    iconProps: { iconName: "textDocument" },
                    name: "showFile",
                    onClick: showDetails,
                }]
                if (selectedStoreDocs[0].fileExists == true) {
                    downloadButton = [{
                        key: "downloadFile",
                        text: t("storeDocs.commands.download"),
                        iconProps: { iconName: "download" },
                        name: "downloadFile",
                        onClick: downloadFile,
                    }]
                }
                if (selectedStoreDocs[0].documentStatus == DocumentStatusEnum.BUFFOR) {
                    let approveButton = [{
                        key: "approve",
                        text: t("storeDocs.commands.approve"),
                        iconProps: { iconName: "CheckMark" },
                        name: "approve",
                        onClick: approveDoc,
                    }];
                    return [...showButton, ...downloadButton, ...approveButton]
                }
                else if (selectedStoreDocs[0].documentStatus == DocumentStatusEnum.APPROVED) {
                    let cancelButton = [
                        {
                            key: "cancel",
                            text: t("storeDocs.commands.cancel"),
                            iconProps: { iconName: "Cancel" },
                            name: "cancel",
                            onClick: cancelDoc,
                        }];
                    return [...showButton, ...downloadButton, ...cancelButton];
                }
                else if (selectedStoreDocs[0].documentStatus == DocumentStatusEnum.CANCELED) {
                    return showButton;
                }
                else {
                    return downloadButton;
                }

            default:
                return [];
        }
    };

    const items = generateItems()

    return {
        items
    }
};